import { render, staticRenderFns } from "./AlertDropdownButton.vue?vue&type=template&id=952d1078&"
import script from "./AlertDropdownButton.vue?vue&type=script&lang=js&"
export * from "./AlertDropdownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports